var map = {
	"./Anyswap.png": 404,
	"./Anyswap.svg": 405,
	"./Artwork.svg": 406,
	"./Artwork_gmx.svg": 407,
	"./Banxa.png": 408,
	"./DROP_DOWN.svg": 223,
	"./Hop.png": 409,
	"./Hop.svg": 410,
	"./Hop_dark.png": 411,
	"./Hop_dark.svg": 412,
	"./Synapse.png": 413,
	"./Synapse.svg": 414,
	"./banner-avt.png": 298,
	"./banner-bg-small-ip.png": 415,
	"./banner-bg-small-mobile.png": 416,
	"./banner-bg-small.png": 417,
	"./banner-bg.png": 418,
	"./banner-vector.png": 299,
	"./bg.png": 419,
	"./binance.png": 420,
	"./bitkeep.svg": 421,
	"./bscscan.png": 422,
	"./btn_big_arbitrum.png": 423,
	"./btn_big_avalanche.png": 424,
	"./btn_big_bsc.png": 425,
	"./btn_big_purchasegmx.png": 426,
	"./buy_gmx.svg": 224,
	"./buy_gmx_bond.svg": 427,
	"./buy_transfer_eth.svg": 428,
	"./coinbaseWallet.png": 225,
	"./coingecko.png": 429,
	"./cross.svg": 430,
	"./dog.jpeg": 431,
	"./dog.svg": 226,
	"./dropdown-ic.svg": 227,
	"./flag_de.svg": 432,
	"./flag_en.svg": 433,
	"./flag_es.svg": 434,
	"./flag_fr.svg": 435,
	"./flag_ja.svg": 436,
	"./flag_ko.svg": 437,
	"./flag_ru.svg": 438,
	"./flag_zh.svg": 439,
	"./ftm.svg": 195,
	"./gateio.svg": 440,
	"./glp_icon.svg": 441,
	"./gmx-logo-final-white-small.png": 442,
	"./gmx-logo-with-name.svg": 228,
	"./ic-communityproject.svg": 443,
	"./ic_1inch.svg": 444,
	"./ic_across.svg": 445,
	"./ic_arbitrum_16.svg": 446,
	"./ic_arbitrum_24.svg": 229,
	"./ic_arbitrum_96.svg": 196,
	"./ic_arbitrum_hover_16.svg": 447,
	"./ic_arrowleft16.svg": 448,
	"./ic_arrowright16.svg": 449,
	"./ic_avalanche_16.svg": 450,
	"./ic_avalanche_24.svg": 451,
	"./ic_avalanche_96.svg": 197,
	"./ic_avalanche_testnet_16.svg": 452,
	"./ic_avalanche_testnet_24.svg": 230,
	"./ic_avalanche_testnet_96.svg": 453,
	"./ic_avax_24.svg": 454,
	"./ic_avax_30.svg": 455,
	"./ic_avax_40.svg": 456,
	"./ic_banxa.svg": 457,
	"./ic_binance.svg": 458,
	"./ic_binance_logo.svg": 459,
	"./ic_bondprotocol_arbitrum.svg": 231,
	"./ic_bone_16.svg": 460,
	"./ic_bone_24.svg": 198,
	"./ic_bone_40.svg": 461,
	"./ic_bone_96.svg": 462,
	"./ic_bsc.svg": 463,
	"./ic_bsc_96.svg": 464,
	"./ic_btc.b_24.svg": 465,
	"./ic_btc.b_40.svg": 466,
	"./ic_btc_24.svg": 467,
	"./ic_btc_40.svg": 468,
	"./ic_bungee.png": 469,
	"./ic_busd_24.svg": 470,
	"./ic_buy_glp.svg": 471,
	"./ic_bybit.svg": 472,
	"./ic_cash.png": 473,
	"./ic_cash.svg": 474,
	"./ic_checked.svg": 232,
	"./ic_coingecko_16.svg": 233,
	"./ic_coingecko_hover_16.svg": 475,
	"./ic_convert_down.svg": 234,
	"./ic_copy_16.svg": 235,
	"./ic_cost.svg": 236,
	"./ic_dai_24.svg": 476,
	"./ic_dai_40.svg": 477,
	"./ic_discord.svg": 237,
	"./ic_dodo.svg": 478,
	"./ic_eth_16.svg": 167,
	"./ic_eth_24.svg": 199,
	"./ic_eth_40.svg": 238,
	"./ic_firebird.png": 479,
	"./ic_frax_24.svg": 480,
	"./ic_frax_40.svg": 481,
	"./ic_ftm_16.svg": 239,
	"./ic_ftm_24.svg": 240,
	"./ic_ftm_40.svg": 482,
	"./ic_github.svg": 241,
	"./ic_glp_24.svg": 483,
	"./ic_glp_40.svg": 242,
	"./ic_glp_arbitrum.svg": 243,
	"./ic_glp_avax.svg": 115,
	"./ic_glp_custom.svg": 484,
	"./ic_gmx.svg": 485,
	"./ic_gmx_24.svg": 486,
	"./ic_gmx_30.svg": 487,
	"./ic_gmx_40.svg": 244,
	"./ic_gmx_64.svg": 488,
	"./ic_gmx_arbitrum.svg": 245,
	"./ic_gmx_avax.svg": 116,
	"./ic_gmx_big.svg": 489,
	"./ic_gmx_custom.svg": 490,
	"./ic_goerli_24.svg": 200,
	"./ic_hop.svg": 491,
	"./ic_huobi.svg": 492,
	"./ic_info.svg": 168,
	"./ic_kucoin.svg": 493,
	"./ic_kyberswap.svg": 494,
	"./ic_language24.svg": 145,
	"./ic_link_24.svg": 495,
	"./ic_link_40.svg": 496,
	"./ic_liquidity.svg": 246,
	"./ic_matcha.png": 497,
	"./ic_matic_16.svg": 247,
	"./ic_matic_24.svg": 498,
	"./ic_matic_40.svg": 499,
	"./ic_medium.svg": 248,
	"./ic_menu_dots.svg": 500,
	"./ic_metamask_16.svg": 249,
	"./ic_metamask_hover_16.svg": 501,
	"./ic_mim_24.svg": 502,
	"./ic_mim_40.svg": 503,
	"./ic_mint.svg": 140,
	"./ic_multiswap.svg": 504,
	"./ic_new_link_16.svg": 250,
	"./ic_o3.png": 505,
	"./ic_odos.png": 506,
	"./ic_olympus.svg": 507,
	"./ic_olympus_arbitrum.svg": 508,
	"./ic_openocean.svg": 509,
	"./ic_paraswap.svg": 510,
	"./ic_puppy_24.svg": 251,
	"./ic_selector_dropdowns.svg": 511,
	"./ic_settings_16.svg": 201,
	"./ic_settings_24.svg": 512,
	"./ic_shib_16.svg": 169,
	"./ic_shib_24.svg": 202,
	"./ic_shib_40.svg": 513,
	"./ic_shib_64.svg": 252,
	"./ic_sign in_16.svg": 514,
	"./ic_sign_out_16.svg": 253,
	"./ic_simpleswaps.svg": 254,
	"./ic_slingshot.svg": 515,
	"./ic_stats.svg": 300,
	"./ic_stats_big.svg": 516,
	"./ic_synapse.svg": 517,
	"./ic_tail_16.svg": 518,
	"./ic_tail_24.svg": 519,
	"./ic_tail_40.svg": 67,
	"./ic_tail_96.svg": 520,
	"./ic_tansak.svg": 521,
	"./ic_telegram.svg": 255,
	"./ic_tether_24.svg": 522,
	"./ic_tlp1_16.svg": 523,
	"./ic_tlp1_24.svg": 524,
	"./ic_tlp1_40.svg": 525,
	"./ic_tlp1_96.svg": 526,
	"./ic_tlp_16.svg": 527,
	"./ic_tlp_24.svg": 528,
	"./ic_tlp_40.svg": 97,
	"./ic_tlp_96.svg": 529,
	"./ic_tokens.svg": 530,
	"./ic_totaluser.svg": 301,
	"./ic_traderjoe_avax.png": 256,
	"./ic_trading.svg": 302,
	"./ic_transfer_avax.svg": 531,
	"./ic_twitter.svg": 257,
	"./ic_uni_24.svg": 532,
	"./ic_uni_40.svg": 533,
	"./ic_uni_arbitrum.svg": 258,
	"./ic_unidex.png": 534,
	"./ic_usdc.e_24.svg": 535,
	"./ic_usdc.e_40.svg": 536,
	"./ic_usdc_24.svg": 537,
	"./ic_usdc_40.svg": 538,
	"./ic_usdm_24.svg": 539,
	"./ic_usdm_40.svg": 540,
	"./ic_usdt_24.svg": 541,
	"./ic_usdt_40.svg": 542,
	"./ic_wallet_24.svg": 259,
	"./ic_wavax_24.svg": 543,
	"./ic_wavax_40.svg": 544,
	"./ic_wbtc_24.svg": 545,
	"./ic_wbtc_40.svg": 546,
	"./ic_weth_24.svg": 547,
	"./ic_weth_40.svg": 548,
	"./ic_wftm_24.svg": 549,
	"./ic_wftm_40.svg": 550,
	"./ic_wmatic_40.svg": 551,
	"./ic_yield_yak.png": 552,
	"./img_right.svg": 260,
	"./lg_arbitrum.svg": 553,
	"./link-green.svg": 554,
	"./link-white.svg": 261,
	"./link.svg": 101,
	"./logo_TAIL.svg": 102,
	"./logo_mb.svg": 262,
	"./long.svg": 263,
	"./metamask-text.svg": 555,
	"./metamask.png": 264,
	"./mum.png": 146,
	"./mum1.png": 110,
	"./mum2.png": 141,
	"./nansen_portfolio.svg": 265,
	"./page-not-found.svg": 556,
	"./position-share-bg.png": 266,
	"./short.svg": 267,
	"./swap.svg": 268,
	"./tail-bone.svg": 269,
	"./tail-eth.svg": 270,
	"./tail-goerli.svg": 271,
	"./tail-usdc.svg": 272,
	"./wallet-connect-text.svg": 557,
	"./walletconnect-circle-blue.svg": 273,
	"./wave-01.png": 558
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 403;